<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 9 7"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path d="M0.5 0.5H8.5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" />
  <path d="M0.5 3.5H8.5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" />
  <path d="M0.5 6.5H8.5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" />
</svg>
